/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'

import EditableTable from '@/components/Table/EditableTable'
import { isNullish } from '@/utils/helper'
import { createColumnHelper } from '@tanstack/react-table'
import { useWatch } from 'react-hook-form'
import useVendor from '@/features/vendors/useVendor'
import { formatCurrencyAmount } from '@/utils/stringHelper'
import { Currency } from '@eapproval/offer-shared'

const getSourcingSelection = (costBudget, vendorId, historyIndex, vendorOptions = []) => {
  if (!Array.isArray(costBudget?.detail.subcontractors) || isNullish(vendorId) || vendorId === '') {
    return '(-)'
  }

  const selectedVendorDetail = costBudget.detail.subcontractors.find((vendorDetail) => vendorDetail.vendor === vendorId)

  const vendor = vendorOptions.find((opt) => opt.value === vendorId)

  if (!vendor) return '(-)'
  if (
    !selectedVendorDetail ||
    !Array.isArray(selectedVendorDetail.history) ||
    selectedVendorDetail.history.length < historyIndex
  ) {
    return '(Vendor Not selected)'
  }
  if (isNullish(historyIndex) || historyIndex === -1) {
    return `${vendor.label} - (Quotation Not selected)`
  }

  const selectedQuotation = selectedVendorDetail.history[historyIndex]

  if (!selectedQuotation || isNullish(selectedQuotation.budget)) {
    return `${vendor.label} - (Quotation Not selected)`
  }

  return `${vendor.label} - ${formatCurrencyAmount(selectedQuotation.budget, selectedQuotation.currency ?? Currency.HKD)}`
}

const OfferSourcingSummaryTable = () => {
  const costBudgets = useWatch({ name: 'sourcing.costBudgets' }) ?? []
  const columnHelper = createColumnHelper()

  const { useVendorOptions } = useVendor()
  const { data: vendorOptions } = useVendorOptions({ valueKey: '_id' })

  const costBudgetData = costBudgets
    .filter((costBudget) => costBudget?.firstTechnicalSelection?.vendor !== 'reference' && costBudget?.detail?.isActive)
    .map((costBudget, index) => {
      let PM040SourcingSelection = getSourcingSelection(
        costBudget,
        costBudget.firstProcurementOfficerSelection?.vendor,
        costBudget.firstProcurementOfficerSelection?.uploadHistoryIndex,
        vendorOptions
      )
      let PM040TechnicalSelection = getSourcingSelection(
        costBudget,
        costBudget.firstTechnicalSelection?.vendor,
        costBudget.firstTechnicalSelection?.uploadHistoryIndex,
        vendorOptions
      )

      return {
        index: index + 1,
        purpose: costBudget?.detail?.purpose,
        PM040SourcingSelection: PM040SourcingSelection,
        PM040TechnicalSelection: PM040TechnicalSelection,
        sourcingComment: costBudget?.firstProcurementOfficerSelection?.remark || '',
      }
    })

  const columnDef = useMemo(
    () => [
      columnHelper.accessor('index', {
        header: () => <span>Cost Budget</span>,
        size: 100,
      }),
      columnHelper.accessor('purpose', {
        header: () => <span>Scope of supply</span>,
        size: 100,
      }),
      columnHelper.accessor('PM040SourcingSelection', {
        header: () => <span>PM040 Sourcing Selection</span>,
        size: 200,
      }),
      columnHelper.accessor('PM040TechnicalSelection', {
        header: () => <span>PM040 Technical Selection</span>,
        size: 200,
      }),
      columnHelper.accessor('sourcingComment', {
        header: () => <span>Sourcing Comment</span>,
        size: 100,
      }),
    ],
    [columnHelper]
  )

  return <EditableTable stickyHeader columnDef={columnDef} data={costBudgetData} disabled={true} tableWidth="100%" />
}

export default OfferSourcingSummaryTable
